module.exports = __webpack_public_path__ + "static/media/ironforgeInside.5578c91a.jpg";